<div class="modal-header">
  <div class="d-flex">
    <div class="action-icon">
      <i *ngIf="Action.actionIcon" class="bi fs-3 me-3 {{ Action.actionIcon }}"></i>
    </div>
    <h5 class="modal-title">{{ ConfirmationTitle }}</h5>
  </div>
</div>

<div class="modal-body p-4">
  <p class="text-secondary mb-1" [innerHTML]="ConfirmationMessage"></p>
  <div class="form-group mb-4">
    <div class="input-group">
      <select class="form-select form-control" id="patientCallingStatus" [(ngModel)]="SelectedStatus" aria-label="patientStatus">
        <ng-container *ngFor="let patientStatus of PatientCallingStatus">
          <option [value]="patientStatus.key">{{ patientStatus.value }}</option>
        </ng-container>
      </select>
    </div>
  </div>
  <div class="form-group">
    <div class="input-group">
      <label for="note">Note</label>
      <textarea [(ngModel)]="AdditionalNotes" class="form-control h-auto" id="note" placeholder="Enter note"></textarea>
    </div>
  </div>
</div>
<div class="d-flex gap-3 justify-content-end pb-4 px-4">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">Cancel</button>
  <button type="button" class="btn {{ Action.actionClass || 'btn-primary' }}" (click)="OnSubmit()">
    {{ Action.actionName || 'Yes' }}
  </button>
</div>
